module.exports = __webpack_public_path__ + "img/clock.aa736eff.svg";